import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import styled from 'styled-components';
import { DashboardQuery } from 'src/graphql/_generated';
import { AssessmentState } from '../types';
import { DangerTooltip } from '../comps';

const Wrap = styled(BaseCard)`
  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    height: 100%;

    &__item {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
`;

interface OverviewmeProps {
  value: DashboardQuery['assessment'];
  state: AssessmentState;
}

export const Overview: React.FC<OverviewmeProps> = ({ state, value }) => {
  return (
    <Wrap>
      <span className="c-title">Overview</span>

      <div className="grid">
        <div className="grid__item">
          <Poppins px={12} weight={500}>
            SCENARIOS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>in the assessment</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins className="value" weight={600} px={26}>
              {value?.scenarios?.length}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            CONTROLS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>linked to scenarios</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' || state === 'SCENARIOS_NO_CONTROLS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins className="value" weight={600} px={26}>
              {value?.scenarios?.reduce((acc, scenario) => acc + scenario.riskManagementPlans.length, 0)}
            </Poppins>
          )}
        </div>

        <div className="grid__item">
          <Poppins px={12} weight={500}>
            MODIFIERS
          </Poppins>
          <Poppins px={12} color="cflowerBlue">
            <i>refelecting how the controls reduce risk</i>
          </Poppins>
          <div style={{ flex: 1 }} />

          {state === 'NO_SCENARIOS' ||
          state === 'SCENARIOS_NO_CONTROLS' ||
          state === 'SCENARIOS_CONTROLS_NO_MODIFIERS' ? (
            <DangerTooltip state={state} />
          ) : (
            <Poppins className="value" weight={600} px={26}>
              {value?.scenarios?.reduce(
                (acc, scenario) =>
                  acc + scenario.riskManagementPlans.reduce((planAcc, plan) => planAcc + plan.modifiers.length, 0),
                0,
              )}
            </Poppins>
          )}
        </div>
      </div>
    </Wrap>
  );
};
